import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import _ from 'lodash';
import moment from 'moment-timezone';
import { SLOT_DURATION, SLOTS_IN_HOUR } from 'ziphy-web-shared/basic/entities/schedules';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import { CARD_HEIGHT } from '../../Calendar.constants';
import { $calendar } from '../../Calendar.store';
import styles from './TimeGrid.module.scss';
import Timeline from './timeline/Timeline';
const TimeGrid = ({ className, isShowTimeline }) => {
    const today = moment.tz($calendar.timezone).startOf('day');
    const slotsRange = _.range($calendar.timeLimits.startIndex, $calendar.timeLimits.endIndex + 1);
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, className), style: {
            gridTemplateColumns: '60px 1fr',
            gridTemplateRows: `repeat(${slotsRange.length}, ${CARD_HEIGHT + 5}px)`,
        } }, { children: [slotsRange.map((slotIndex, index) => {
                const isFirst = index === 0;
                const isLast = index === slotsRange.length - 1;
                const isHour = slotIndex % SLOTS_IN_HOUR === 0;
                const isVisible = isFirst || isHour || isLast;
                return (_jsxs(Fragment, { children: [_jsx("div", Object.assign({ className: styles.time }, { children: isVisible &&
                                formatDate(today.clone().add(slotIndex * SLOT_DURATION, 'minutes'), {
                                    format: 'time',
                                    timezone: $calendar.timezone,
                                }) })), _jsx("div", { className: classNames(styles.bgLine, isVisible && styles.isVisible) })] }, [index, slotIndex].join('_')));
            }), _jsx(Timeline, { show: isShowTimeline !== null && isShowTimeline !== void 0 ? isShowTimeline : Object.keys($calendar.schedule).includes(today.format('YYYY-MM-DD')), startIndex: slotsRange[0], endIndex: slotsRange[slotsRange.length - 1], topPadding: 20 })] })));
};
export default observer(TimeGrid);
